import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import * as fromT2Codes from './+state/t2-codes.reducer';
import { T2CodesEffects } from './+state/t2-codes.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromT2Codes.T2_CODES_FEATURE_KEY,
      fromT2Codes.t2CodesReducer
    ),
    EffectsModule.forFeature([T2CodesEffects]),
  ],
})
export class SharedDataAccessT2CodesModule {}
